import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateFn = (_route, state) => {
  const perm   = inject(PermissionService);
  const router = inject(Router);

  const path = state.url.split('?')[0].split('#')[0];
  if (perm.canAccessRoute(path)) return true;

  router.navigate(['/dashboard']);
  return false;
};
